import t from"./implementation.js";var o=t,e=Function.prototype.bind||o;export{e as default};
